import { useState, useEffect } from "react";
import "./Services.css";

const API_URL = process.env.REACT_APP_API_URL || "/api/v1";

const ArrowRightIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12"/>
    <polyline points="12 5 19 12 12 19"/>
  </svg>
);

function useServicesData() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_URL}/images/?section=services`)
      .then(r => r.ok ? r.json() : [])
      .then(data => {
        setServices([...data].sort((a, b) => a.sort_order - b.sort_order));
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return { services, loading };
}

export default function Services() {
  const { services, loading } = useServicesData();

  if (loading) {
    return (
      <section id="services" className="services">
        <div className="services__inner" />
      </section>
    );
  }

  if (services.length === 0) return null;

  return (
    <section id="services" className="services">
      <div className="services__inner">
        <div className="services__header">
          <p className="services__label">Наша экспертиза</p>
          <h2 className="services__title">Направления работ</h2>
        </div>

        <div className="services__list">
          {services.map((item, index) => (
            <div
              key={item.id}
              className={`services__row${index % 2 !== 0 ? " services__row--reversed" : ""}`}
            >
              <div className="services__row-img-wrap">
                <img
                  src={`${API_URL}/images/${item.id}/file`}
                  alt={item.title}
                  className="services__row-img"
                />
              </div>

              <div className="services__row-body">
                <div className="services__row-meta">
                  <span className="services__row-num">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  {item.category && (
                    <span className="services__row-tag">{item.category}</span>
                  )}
                </div>

                <h3 className="services__row-title">{item.title}</h3>

                {item.description && (
                  <p className="services__row-desc">{item.description}</p>
                )}

                <div className="services__row-arrow">
                  <ArrowRightIcon />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
